module.exports = __webpack_public_path__ + "static/img/background.51d53335.png";